<template>
  <!-- 弘知动态-新闻详情 -->
  <div
    class="box"
    style="min-width: 1600px;"
  >
    <NavBar
      navIndex="7"
      :imgHeight="482"
    ></NavBar>
    <!-- <div style="padding:30px;"></div> -->
    <div style="position:relative;width: 100%;">
      <img
        src="../assets/dynamic-bg.png"
        alt=""
        class="mod-section-ad"
      >
      <div class="animate__animated animate__mian slogan">
        <div class="slogan-title">多维动态</div>
        <div class="slogan-subtitle">
          有深度、有温度、有态度
        </div>
      </div>
    </div>

    <div style="background-color: #F7F7F7;padding: 10px 0px 50px;">
      <div style="width: 1200px;margin: auto;">
        <div style="display: flex;align-items: center;margin: 20px 0;">
          <div
            class="select-status word-style"
            @click="goHome()"
          > 首页 </div>
          <div style="margin: 0 10px;color: #666;"> > </div>
          <div
            class="select-status word-style"
            @click="showDynamic()"
          >弘知动态</div>
          <div style="margin: 0 10px;color: #666;"> > </div>
          <div style="cursor:pointer;color: #666;">新闻详情</div>

        </div>

        <div style="background-color: #fff;padding: 50px 40px;box-sizing: border-box;">
          <!-- 标题 -->
          <div style="font-size: 34px;text-align: center;font-family: PingFang-Bold;">
            {{dynamicObj.dynamicName}}
          </div>
          <!-- 副标题 -->
          <div style=" font-size: 28px;font-family: 'PingFang-Bold';text-align: center;margin-top: 7px;">
            {{dynamicObj.dynamicTitle}}
          </div>

          <!-- 发布时间 -->
          <div style="color: #999999;text-align: center;margin: 15px 25px;">发布时间： {{dynamicObj.time}}</div>

          <img
            v-if="dynamicObj.dynamicPic"
            :src="dynamicObj.dynamicPic"
            style="display: block;margin: 30px auto;width: 60%;"
            alt=""
          >

          <div
            id="formStr" class="ql-editor"
            v-html="dynamicContent"
          >{{ dynamicContent }}</div>

        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
    
    <script>
import NavBar from "@/components/navBar.vue";
import Footer from "@/components/Footer.vue";
import { dynamicListDetail } from "@/request/api";

export default {
  name: "dynamic_detail",
  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
      page_control: "1",
      jobData: [],
      total: 6,
      jobContent: {}, //工作信息详情
      dynamicObj: {},
      dynamicContent: "", // 新闻内容
    };
  },
  mounted() {
    let that = this;
    let router_data = this.$route.query;
    console.log(this.$route.query);
    dynamicListDetail("id=" + router_data.dynamicId).then((res) => {
      console.log("动态详情", res.data.data);
      let obj = res.data.data;
      obj.time = obj.insertDate.slice(0, 10);
      that.dynamicObj = res.data.data;
      let htl = that.dynamicObj.dynamicText.replace(
        /<p/g,
        "<p style='line-height:32px;' "
      );
      let ddd = htl.replace(
        /<img/g,
        "<img style='width: 60%;display: block;margin: 10px auto;' "
      );
      // console.log(ddd)
      that.dynamicContent = ddd;
      // console.log(that.dynamicContent)
    });
  },
  methods: {
    lookJob(e) {
      let that = this;
      that.page_control = "2";
      console.log(e);
      this.jobContent = e;
    },
    showDynamic() {
      this.$router.push({ name: "photoAlbum", query: { type: "多维动态" } });
    },
    goHome() {
      this.$router.push("/");
    },
    goDynamicDetail(e) {
      console.log("e", e);
    },
  },
};
</script>
    
<style scoped>
@import '../assets/style/quill.core.css';
.content-title-border {
  position: absolute;
  width: 32px;
  height: 4px;
  background-color: #fff;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15%;
}
.job-cell {
  width: 31%;
  background-color: #fff;
  padding: 30px;
  box-sizing: border-box;
  margin: 10px;
  cursor: pointer;
}
.job-cell:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}

.teacher-classify {
  position: relative;
  font-size: 26px;
  font-weight: bold;
  width: 70%;
  margin-bottom: 25px;
}
.teacher-classify-border {
  position: absolute;
  width: 32px;
  height: 2px;
  background-color: #0050a7;
  bottom: -25%;
}

/* 分页 */
.pagination-block {
  text-align: center;
  margin: 30px;
}

.select-status:hover {
  color: #004ea3;
  /* font-weight: 600; */
}
.word-style {
  cursor: pointer;
  color: #666;
}
</style>
            